var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSolidTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Adornment Start"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.9987 1.33331C4.3227 1.33331 1.33203 4.32398 1.33203 7.99998C1.33203 11.676 4.3227 14.6666 7.9987 14.6666C11.6747 14.6666 14.6654 11.676 14.6654 7.99998C14.6654 4.32398 11.6747 1.33331 7.9987 1.33331ZM7.9987 13.3333C5.05803 13.3333 2.66536 10.9406 2.66536 7.99998C2.66536 5.05931 5.05803 2.66665 7.9987 2.66665C10.9394 2.66665 13.332 5.05931 13.332 7.99998C13.332 10.9406 10.9394 13.3333 7.9987 13.3333Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.66536 4.66669H7.33203V8.66669H11.332V7.33335H8.66536V4.66669Z",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSolidTime);
export default __webpack_public_path__ + "static/media/ic-solid-time.bf6f3e9084e7283d2cc7382b2c3749fd.svg";
export { ForwardRef as ReactComponent };